import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import peopleFill from "@iconify/icons-eva/people-fill";
import lockFill from "@iconify/icons-eva/lock-fill";
import settingFill from "@iconify/icons-eva/settings-fill";
import shoppingCartFill from "@iconify/icons-eva/shopping-cart-fill";
import percentFill from "@iconify/icons-eva/percent-fill";
import imageFill from "@iconify/icons-eva/image-fill";
import castFill from "@iconify/icons-eva/cast-fill";
import briefcseFill from "@iconify/icons-eva/briefcase-fill";
import starsFill from "@iconify/icons-eva/star-fill";

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

let sidebarConfig = [
  {
    title: "首页",
    path: "/",
    icon: getIcon(pieChart2Fill),
  },
  {
    title: "用户",
    path: "/user",
    icon: getIcon(peopleFill),
    children: [
      {
        title: "用户列表",
        path: "/user/list",
      },
    ],
  },
  {
    title: "商品",
    path: "/product",
    icon: getIcon(shoppingCartFill),
    children: [
      {
        title: "商品列表",
        path: "/product/list",
      },
      {
        title: "商品规格",
        path: "/product/attr",
      },
    ],
  },
  {
    title: "分销",
    path: "/promote",
    icon: getIcon(shoppingCartFill),
    children: [
      {
        title: "分销设置",
        path: "/promote/setting",
      },
    ],
  },
  {
    title: "营销",
    path: "/marketing",
    icon: getIcon(briefcseFill),
    children: [
      {
        title: "平台优惠券",
        path: "/marketing/pcoupon",
      },
      {
        title: "商户优惠券",
        path: "/marketing/pcoupon",
      },
      {
        title: "商品规格",
        path: "/product/attr",
      },
    ],
  },
  {
    title: "商户",
    path: "/merchant",
    icon: getIcon(shoppingCartFill),
    children: [
      {
        title: "商户分类",
        path: "/merchant/category",
      },
      {
        title: "商户列表",
        path: "/merchant/list",
      },
      {
        title: "商户入住申请",
        path: "/merchant/apply",
      },
      {
        title: "商户菜单管理",
        path: "/merchant/menus",
      },
      {
        title: "店铺类型",
        path: "/merchant/type",
      },
    ],
  },
  {
    title: "资讯",
    path: "/news",
    icon: getIcon(castFill),
    children: [
      {
        title: "资讯分类",
        path: "/news/category",
      },
      {
        title: "资讯列表",
        path: "/news/list",
      },
    ],
  },
  {
    title: "金银通乐园",
    path: "/jingxi",
    icon: getIcon(starsFill),
    children: [
      {
        title: "金银通用户",
        path: "/jingxi/jyt-user/list",
      },
      {
        title: "场次配置",
        path: "/jingxi/session-config",
      },
      {
        title: "用户等级",
        path: "/jingxi/grade",
      },
      {
        title: "场次列表",
        path: "/jingxi/game/sessions",
      },
      {
        title: "游戏订单",
        path: "/jingxi/game/orders",
      },
      {
        title: "机器人配置",
        path: "/jingxi/game/robots",
      },
      {
        title: "派单中心",
        path: "/jingxi/game/dispatch",
      },
      {
        title: "银豆日志",
        path: "/jingxi/dragon-bead-log",
      },
      {
        title: "金豆日志",
        path: "/jingxi/dhz-transfer-log",
      },
      {
        title: "金银通VIP列表",
        path: "/jingxi/jyt-vip/list",
      },
      {
        title: "VIP开通日志",
        path: "/jingxi/jyt-vip/log",
      },
      {
        title: "拍卖API日志",
        path: "/jingxi/auction-api-log",
      },
      {
        title: "操作日志",
        path: "/jingxi/jyt-admin-operation-log",
      },
      {
        title: "释放控制",
        path: "/jingxi/release-control",
      },
      {
        title: "释放总览",
        path: "/jingxi/release-overview",
      },
      {
        title: "支付业务配置",
        path: "/jingxi/payment-config",
      },
    ],
  },
  {
    title: "财务",
    path: "/finance",
    icon: getIcon(percentFill),
    children: [
      {
        title: "积分明细",
        path: "/finance/jifen",
      },
      {
        title: "余额明细",
        path: "/finance/balance",
      },
      {
        title: "支付优惠记录",
        path: "/finance/payment-discount/record",
      },
    ],
  },
  {
    title: "资源库",
    path: "/resource",
    icon: getIcon(imageFill),
    children: [
      {
        title: "图片管理",
        path: "/resource/images",
      },
    ],
  },
  {
    title: "设置",
    path: "/setting",
    icon: getIcon(settingFill),
    children: [
      // {
      //   title: "广告位",
      //   path: "/setting/banner",
      // },
      {
        title: "站点设置",
        path: "/setting/website",
      },
      {
        title: "后台操作日志",
        path: "/system/admin-operation-log",
      },
      // {
      //   title: "界面配置",
      //   path: "/setting/page",
      //   children: [
      //     {
      //       title: "界面列表",
      //       path: "/setting/page/list",
      //     },
      //     {
      //       title: "界面分类",
      //       path: "/setting/page/category",
      //     },
      //   ],
      // },
      {
        title: "权限管理",
        path: "/access",
        icon: getIcon(lockFill),
        children: [
          {
            title: "角色管理",
            path: "/access/roles",
          },
          {
            title: "管理员列表",
            path: "/access/admins",
          },
          {
            title: "系统菜单",
            path: "/access/menus",
          },
          // {
          //   title: "操作日志",
          //   path: "/setting/access/logs",
          // },
        ],
      },
    ],
  },
  {
    title: "维护",
    path: "/dev",
    icon: getIcon(imageFill),
    children: [
      {
        title: "配置分类",
        path: "/dev/configcate",
      },
    ],
  },
];

export default sidebarConfig;
